import API from "../../../utils/api";

export const getOrderReceivedMethodApi = async (filters) => {
  const response = await API.get("settings/order-received-method", { params: filters });
  return { response };
};

export const addOrderReceivedMethodApi = async (data) => {
  const response = await API.post("settings/order-received-method", data);
  return { response };
};

export const updateOrderReceivedMethodApi = async (data, id) => {
  const response = await API.put(`settings/order-received-method/${id}`, data);
  return { response };
};

export const deleteOrderReceivedMethodApi = async (id) => {
  const response = await API.delete(`settings/order-received-method/${id}`);
  return { response };
};
